<template>
  <div
    class="view-loader"
    :class="stateClass">
  </div>
</template>
<script>
export default {
  name: 'ViewLoader',
  props: {
    status: String
  },
  computed: {
    stateClass: function () {
      return this.status === 'loading' ? 'view-loader--is-loading' : 'view-loader--is-hidden'
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './view-loader'
</style>



// WEBPACK FOOTER //
// src/components/ViewLoader/ViewLoader.vue